import { css } from '@emotion/react';
import { color, Icon, Typography } from '@uniquegood/realworld-studio-design';
import { useParamsWithMatchPath, useRequest } from '@/hooks';

export default function Credit() {
  const { appId } = useParamsWithMatchPath();
  const { data: creditValues } = useRequest<CommonResponseModel<RemainCreditInfoResponseModel>>(
    `/apps/${appId}/credit`
  );

  const totalCredit = (creditValues?.data?.freeCredit ?? 0) + (creditValues?.data?.paidCredit ?? 0);

  return (
    <div css={CreditContainer}>
      <svg width="0" height="0" style={{ position: 'absolute' }}>
        <defs>
          <linearGradient id="credit-icon-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" style={{ stopColor: '#4a41ff', stopOpacity: 1 }} />
            <stop offset="100%" style={{ stopColor: '#22f8e2', stopOpacity: 1 }} />
          </linearGradient>
        </defs>
      </svg>
      <div css={GradientIconWrapper}>
        <Icon icon="special_solid" size="24px" />
      </div>
      <Typography as="span" type="body">
        {totalCredit} <span css={CreditLabel}>크레딧</span>
      </Typography>
    </div>
  );
}

const CreditContainer = css`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const CreditLabel = css`
  color: ${color.text_disabled};
`;

const GradientIconWrapper = css`
  display: inline-flex;
  align-items: center;
  justify-content: center;

  svg {
    fill: url(#credit-icon-gradient) !important;
  }

  path {
    fill: url(#credit-icon-gradient) !important;
  }
`;
